import { render, staticRenderFns } from "./le-survey-area-choose.vue?vue&type=template&id=1216a050&"
import script from "./le-survey-area-choose.vue?vue&type=script&lang=js&"
export * from "./le-survey-area-choose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports